import React, { Component } from 'react'
import * as actions from "../actions";
import * as utils from "../../utils";

import DeleteItemLink from "../../common/components/delete-item-link";
import EditCommentLink from "./edit-comment-link";
import EditTagsLink from "./edit-tags-link";

const FeedPostMenu = React.createClass({
  shouldComponentUpdate(nextProps, nextState) {
    return this.state.menuActive || nextState.menuActive;
  },
  getInitialState() {
    return { menuActive: false }
  },
  componentDidUpdate() {
    // Attach/remove an outside click event depending on whether the modal is open
    if (this.state.menuActive) {
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }
  },
  componentWillUnmount() {
    document.removeEventListener('click', this.handleOutsideClick, false);
  },
  render() {
    const { userId, comment, mentions, postId, tags, postType } = this.props;
    const cssClass = this.state.menuActive ? "active" : "";
    return (
      <div className={`feed-post-menu ${cssClass}`} onClick={this.handleMenuClick}>
        <i className="icon-down-open" />
        <ul>
          { utils.canEditEventItem(userId) &&
            <li>
              <EditCommentLink
                comment={comment}
                postId={postId}
                postType={postType}
                mentions={mentions}
              />
            </li>
          }
          { utils.canEditEventItem(userId) &&
            <li>
              <EditTagsLink
                tags={tags}
                postId={postId}
              />
            </li>
          }
          <li className="delete-item-li">
            <DeleteItemLink
              onConfirmClick={this.handleDeleteClick}
              heading="Remove Post"
              body="Are you sure you would like to remove this post?"
              linkText="Delete Post"
              hideIcon="true"
            />
          </li>
        </ul>
      </div>
    );
  },
  handleMenuClick(e) {
    e.preventDefault();
    this.setState({menuActive: !this.state.menuActive});
  },
  handleOutsideClick(e) {
    this.setState({menuActive: false});
  },
  handleDeleteClick() {
    actions.deletePost(this.props.postId);
  }
});

export default FeedPostMenu;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/feed-post-menu.es6